// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"188":"a77f5ac5","856":"37d77139","951":"666c6340"}[chunkId] + ".js";
};